document.addEventListener('DOMContentLoaded', function () {
  let selectedLang = null;

  // Prevent default form submissions (Shopify tries to post locale)
  document.querySelectorAll('.popover__choice-list form').forEach(form => {
    form.addEventListener('submit', e => e.preventDefault());
  });

  const langButtons = document.querySelectorAll('.popover__choice-list button[name="locale_code"]');

  // Translation map for the confirmation message
  const confirmationMessages = {
    'de': 'Alle Auswahl werden zurückgesetzt. <br>Sind Sie sicher, dass Sie die Filter zurücksetzen möchten?',
    'en': 'All selections will be reset. <br>Are you sure you want to reset the filters?',
    'fr': 'Toutes les sélections seront réinitialisées. <br>Êtes-vous sûr de vouloir réinitialiser les filtres ?',
    'it': 'Tutte le selezioni verranno reimpostate. <br>Sei sicuro di voler reimpostare i filtri?'
  };

  langButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      selectedLang = this.value;

      const confirmationMessage = confirmationMessages[selectedLang] || confirmationMessages['en'];
      document.getElementById('lang-reset-msg').innerHTML = confirmationMessage;

      document.getElementById('lang-reset-popup').style.display = 'block';
    });
  });

  document.getElementById('lang-reset-ok').addEventListener('click', function () {
    if (!selectedLang) return;

    const alternateLinks = document.querySelectorAll('link[rel="alternate"]');
    let targetUrl = null;

    alternateLinks.forEach(link => {
      if (link.getAttribute('hreflang') === selectedLang) {
        targetUrl = link.getAttribute('href').split('?')[0];
      }
    });

    if (!targetUrl) {
      const path = window.location.pathname.replace(/^\/(en|fr|it)\//, '').replace(/^\/+/, '');
      const prefix = selectedLang === 'de' ? '' : `/${selectedLang}`;
        targetUrl = `${window.location.origin}${prefix}/${path}`;
    }

    window.location.href = targetUrl;
  });

  document.getElementById('lang-reset-cancel').addEventListener('click', function () {
    document.getElementById('lang-reset-popup').style.display = 'none';
    selectedLang = null;
  });
});
